import api from "./baseApi";
import endpoints from "./endpoints";

export const generateAccessPermit = async (
  reservationId
) => {
  const { data } = await api.post(
    endpoints.accessPermit.generate(reservationId)
  );

  return data;
};

export const sendAccessPermit = async (
  reservationId
) => {
  const { data } = await api.post(
    endpoints.accessPermit.sendEmail(reservationId)
  );

  return data;
};